import { Component, inject } from '@angular/core';
import { LowerCasePipe, NgStyle } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TippyModule } from '@ngneat/helipopper';

import { isMobileView } from '@core/utils';
import { SectionType, TaskType, Visibility } from '@core/enums';
import { NumberInputDirective } from '@shared/directives/number-input.directive';
import { EventFormComposition } from '@shared/compositions/event-form.composition';
import { ButtonComponent, DropdownComponent, IconComponent, ImageSelectorComponent } from '@shared/components/ui';
import { SimpleFileSelectorInputComponent } from '@shared/components/ui/simple-file-selector-input/simple-file-selector-input.component';
import { DatePickerInputComponent, FormErrorComponent, TimePickerInputComponent } from '@shared/components';

@Component({
  selector: 'app-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss'],
  imports: [
    IconComponent,
    ReactiveFormsModule,
    ImageSelectorComponent,
    TranslateModule,
    DatePickerInputComponent,
    DropdownComponent,
    NgSelectModule,
    FormErrorComponent,
    TimePickerInputComponent,
    ButtonComponent,
    NgStyle,
    NumberInputDirective,
    TippyModule,
    SimpleFileSelectorInputComponent,
    LowerCasePipe,
  ],
})
export class EventFormComponent extends EventFormComposition {
  protected readonly isMobileView = isMobileView;
  protected readonly EventVisibility = Visibility;
  protected readonly TasksType = TaskType;
  protected readonly EventTaskType = TaskType;
  protected readonly SectionType = SectionType;
  private readonly _route = inject(ActivatedRoute);

  constructor() {
    super();
    const eventId = this._route.snapshot.paramMap.get('id');
    if (eventId) {
      this.eventId = +eventId;
    }
  }

  get isUpdateMode(): boolean {
    return !!(this._currentSelectedEvent && this._currentSelectedEvent.id && this._currentSelectedEvent.imageUrl);
  }
}
